import React, { useState, useEffect } from 'react';
import './IndexConf.css'
import AngryGirl from '../media/imagen/AngryGirl.svg';

const IndexConf = ({ testID }) => {
    const [statusData, setStatusData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [conflictIndex, setConflictIndex] = useState(null);
    const [description, setDescription] = useState('');

    useEffect(() => {
        const fetchStatusData = async () => {
            try {
                const token = localStorage.getItem('authToken');
                if (!token) throw new Error('Токен авторизации не найден');

                const response = await fetch(
                    `http://185.250.149.189:8000/api/v1/Results/Sociometric/KonflictIndex?test_id=${testID}`,
                    {
                        method: 'GET',
                        headers: {
                            'Authorization': `Token ${token}`,
                            'Content-Type': 'application/json'
                        }
                    }
                );

                if (!response.ok) throw new Error(`Ошибка HTTP: ${response.status}`);
                const result = await response.json();
                setStatusData(result);
                
                // Извлекаем значение индекса конфликтности
                if (result && result.results) {
                    const kg = result.results.index_konflict;
                    setConflictIndex(kg.toFixed(2));
                    
                    // Определяем описание на основе значения
                    if (kg === 0) {
                        setDescription('Полное отсутствие конфликтов в группе. Коллектив работает слаженно, отсутствуют отрицательные взаимодействия между участниками.');
                    } else if (kg <= 0.25) {
                        setDescription('Низкая конфликтность. Группа относительно сплочённая, отрицательных выборов мало. Рекомендуется укрепление командного духа.');
                    } else if (kg <= 0.5) {
                        setDescription('Умеренная конфликтность. Присутствует заметное напряжение между участниками. Рекомендуется обратить внимание на эмоциональные взаимоотношения.');
                    } else if (kg <= 0.75) {
                        setDescription('Высокая конфликтность. Значительная часть группы находится в конфликте. Необходимо принять меры для снижения напряжённости.');
                    } else {
                        setDescription('Очень высокая конфликтность. Группа разобщена, высокая напряжённость. Требуется немедленное вмешательство и коррекция.');
                    }
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchStatusData();
    }, [testID]);

    if (loading) return <div className="loading">Загрузка данных...</div>;
    if (error) return <div className="error">Ошибка: {error}</div>;
    if (!statusData || !statusData.results) return <div className="no-data">Нет данных для отображения</div>;

    return (
        <div className='IndexConfContainer'> 
            <div className='IndexBlock'>
                <h2>Индекс конфликтности</h2>
                <span className='BigIndex'>{conflictIndex}</span>
                <br />
                <span className='Index-des'>{description}</span>
                <div>
                    __________
                    <br /><br />
                    <span className='Index-help'>Индекс конфликтности характеризует конфликтный потенциал группы представляет собою индекс отрицательной взаимности, указывает на наличие и степень взаимно отрицающих пар. Присутствие таких пар снижает процессы консолидации структуры, уменьшает способность группы сохранять равновесие.</span>
                </div>
            </div>
            <img 
                src={AngryGirl} 
                alt="AngryGirl" 
            />
        </div>
    );
};

export default IndexConf;